// removed by extract-text-webpack-plugin
module.exports = {"logo":"_3_Mx","dragon":"_3_MY","r1":"_1O7L","l1":"uWfi","r2":"MB-9","l2":"_3F_h","r3":"_2H-J","l3":"cxtl","r4":"_6Ugg","l4":"_3LK1"};


//////////////////
// WEBPACK FOOTER
// ./src/components/logo/index.less
// module id = 262
// module chunks = 0